import { useEffect } from "react";
import { history, MeuUsuarioService, SessionService } from "../../services";
import { StorageHelper } from "../../helpers";
import store from "../../config/store";
import "./loading.style.scss";
const versaoMobileAtiva = false;

const LoadingView = () => {
  const meuUsuarioService = new MeuUsuarioService();
  const sessionService = new SessionService();
  const storageHelper = new StorageHelper();
  const images = {
    logo: "https://public.siafevolution.com.br/icon-lite.svg",
  };

  useEffect(() => {
    if (versaoMobileAtiva) {
      verificarVersaoMobile();
    }
    verificaToken();
  }, []);

  const verificarVersaoMobile = () => {
    if (navigator.userAgentData) {
      if (navigator.userAgentData.mobile) {
        return window.location.replace(store.urlMobile);
      }
      return;
    }
    if (navigator.userAgent) {
      if (/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        return window.location.replace(store.urlMobile);
      }
      return;
    }
    if (window.matchMedia("(max-width: 768px)").matches) {
      return window.location.replace(store.urlMobile);
    }
  };

  const verificaToken = () => {
    const token = storageHelper.getLocal("token");
    if (!token) {
      return history.push("/login");
    }
    meuUsuarioService.validarToken().then((result) => {
      if (!result.isAxiosError) {
        return history.push("/dashboard");
      }
      return sessionService.deslogar();
    });
  };

  return (
    <div className="inicio-container">
      <img src={images.logo} className="inicio-container-img" />
    </div>
  );
};

export default LoadingView;
